module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-100-thin-italic-7c9f08169510841e1d0cb877bec278ff.woff2";